export enum PropertyCountry {
  FR = 'fr',
}

export enum PropertyOfferType {
  SALE = 'sale',
  RENTAL = 'rental',
  LIFE_ANNUITY = 'life_annuity', // Viager
  FORWARD_SALE = 'forward_sale', // Vente à terme
}

export enum PropertyType {
  APARTMENT = 'apartment',
  HOUSE = 'house',
  PARKING_BOX = 'parking_box', // Regroupe Garage et Parking
  LAND = 'land', // Terrain
  BUSINESS = 'business', // Fond de commerce
  PROFESSIONAL = 'professional', // Immobilier pro
}

export enum PropertyApartmentSubType {
  LOFT = 'loft', // Loft/Atelier
  SIMPLEX = 'simplex',
  DUPLEX = 'duplex',
  TRIPLEX = 'triplex',
  SOUFLEX = 'souflex',
}

export enum PropertyHouseSubType {
  TERRACED = 'terraced', // Mitoyen
  VILLA = 'villa',
  FARM = 'farm', // Ferme
  MANOR = 'manor', // Manoir
  CASTLE = 'castle', // Château
  BARN = 'barn', // Grange
  PROPERTY = 'property', // Propriété
  OTHER = 'other',
}

export enum PropertyCommercialSubType {
  HOTEL = 'hotel',
  SHOP = 'shop',
  PRESS = 'press',
  RESTAURANT = 'restaurant',
  BAR = 'bar',
  // Add more as needed
}

export enum PropertyLandSubType {
  BUILDING = 'building', // Constructible
  AGRICULTURAL = 'agricultural', // Agricole
  LEISURE = 'leisure', // Loisir
  NON_BUILDING = 'non_building', // Non constructible
}

export enum PropertyParkingSubType {
  GARAGE = 'garage',
  DOUBLE_GARAGE = 'double_garage',
  COVERED = 'covered',
  OUTDOOR = 'outdoor',
  BOX = 'box',
  UNDERGROUND = 'underground',
  CARPORT = 'carport',
  STREET_PARKING = 'street_parking',
}

export enum PropertyProfessionalSubType {
  SHOP = 'shop', // Boutique
  OFFICE = 'office',
  WAREHOUSE = 'warehouse',
  COMMERCIAL_PREMISES = 'commercial_premises',
  INDUSTRIAL = 'industrial',
  // Add more as needed
}

export enum PropertyOccupationState {
  FREE = 'free',
  OCCUPIED = 'occupied',
}

export enum DpeState {
  TO_DO = 'to_do',
  IN_PROGRESS = 'in_progress',
  NOT_SUBJECT = 'not_subject',
  DONE = 'done',
}

export enum PropertyGeolocationType {
  NEIGHBORHOOD = 'neighborhood',
  CITY = 'city',
  REGION = 'region',
}

export enum PropertyHeatingType {
  INDIVIDUAL = 'individual',
  COLLECTIVE = 'collective',
}

export enum PropertyHeatingEnergy {
  ELECTRICITY = 'electricity',
  GAS = 'gas',
  OIL = 'oil', // Fioul
  WOOD = 'wood',
  SOLAR = 'solar',
  GEOTHERMAL = 'geothermal', // Géothermie
  AEROTHERMAL = 'aerothermal', // Aérothermie
  HEAT_PUMP = 'heat_pump', // Pompe à chaleur
  OTHER = 'other',
  NONE = 'none', // Aucun
  UNDERFLOOR = 'underfloor', // Au sol
  AIR_CONDITIONING = 'air_conditioning', // Climatisation
  PELLETS = 'pellets', // Granulé
}

export enum PropertyCondition {
  AS_NEW = 'as_new', // Comme neuf
  GOOD = 'good', // Bon état
  PARTIALLY_RENOVATED = 'partially_renovated', // Partiellement rénové
  RENOVATION_NEEDED = 'renovation_needed', // Partiellement rénové
  TO_BE_DEMOLISHED = 'to_be_demolished', // Destiné à être démoli
}

export enum PropertyConstructionMaterial {
  STONE = 'stone', // Pierre
  BRICK = 'brick', // Brique
  CONCRETE = 'concrete', // Béton
  WOOD = 'wood', // Bois
  CINDERBLOCK = 'cinderblock', // Parpaing
  RAMMED_EARTH = 'rammed_earth', // Pisé / Terre
  METAL = 'metal', // Métal
  OTHER = 'other',
}

export enum PropertyRoofMaterial {
  TILES = 'tiles', // Tuiles
  SLATE = 'slate', // Ardoises
  ZINC = 'zinc', // Zinc
  THATCH = 'thatch', // Chaume
  CONCRETE = 'concrete', // Béton / Terrasse
  SHINGLE = 'shingle', // Bardeau bitumé
  METAL = 'metal', // Bac acier / Métal
  OTHER = 'other',
}
export enum PropertyRoomType {
  LIVING_ROOM = 'living_room', // Salon
  DINING_ROOM = 'dining_room', // Salle à manger
  OFFICE = 'office', // Bureau
  MUSIC_STUDIO = 'music_studio', // Bureau
  LIBRARY = 'library', // Bibliothèque
  WORKSHOP = 'workshop', // Atelier
  LAUNDRY_ROOM = 'laundry_room', // Buanderie
  GYM = 'gym', // Salle de sport
  PLAYROOM = 'playroom', // Salle de jeux
  KITCHEN = 'kitchen', // Cuisine
  STORAGE = 'storage', // Débarras
  BASEMENT = 'basement', // Cave
  ATTIC = 'attic', // Grenier
  OTHER = 'other',
}

export enum PropertyCommonAreaType {
  HALL = 'hall', // Hall
  SWIMMING_POOL = 'swimming_pool', // Piscine
  GARDEN = 'garden', // Jardin
  COURTYARD = 'courtyard', // Cour
  PARK = 'park', // Parc
  BIKE_ROOM = 'bike_room', // Local vélo
  STROLLER_ROOM = 'stroller_room', // Local poussette
  TRASH_ROOM = 'trash_room', // Local poubelle
  MEETING_ROOM = 'meeting_room', // Salle de réunion
  GYM = 'gym', // Salle de sport
  OTHER = 'other',
}

export enum PropertyOrientation {
  NORTH = 'north',
  NORTH_EAST = 'north_east',
  NORTH_WEST = 'north_west',
  SOUTH = 'south',
  SOUTH_EAST = 'south_east',
  SOUTH_WEST = 'south_west',
  EAST = 'east',
  WEST = 'west',
}

export enum PropertyCoOwnershipProcedureType {
  ALERT = 'alert', // Procédure d'alerte
  JUDICIAL_REORGANIZATION = 'judicial_reorganization', // Redressement judiciaire
  DEFICIENCY_STATE = 'deficiency_state', // État de carence
  OTHER = 'other',
}

export enum PropertyExposure {
  FAINT = 'faint', // Faible (peu ou pas de soleil direct)
  MODERATE = 'moderate', // Modérée (soleil une partie de la journée)
  GOOD = 'good', // Bonne (ensoleillé plusieurs heures par jour)
  EXCELLENT = 'excellent', // Très bonne (ensoleillé toute la journée)
}

export enum PropertyEquipment {
  FURNISHING = 'furnishing',
  AIR_CONDITIONING = 'air_conditioning',
  KITCHEN_EQUIPMENT = 'kitchen_equipment',
  VENTILATION = 'ventilation',
  FIBER_OPTIC = 'fiber_optic',
  ALARM = 'alarm',
  HOME_AUTOMATION = 'home_automation',
  INTERCOM = 'intercom',
  DIGICODE = 'digicode',
  ELECTRIC_GATE = 'electric_gate',
  SECURITY_CAMERA = 'security_camera',
}

export enum PropertyConstructionPeriod {
  BEFORE_1850 = 'before_1850',
  PERIOD_1850_1913 = '1850_1913',
  PERIOD_1914_1947 = '1914_1947',
  PERIOD_1948_1969 = '1948_1969',
  PERIOD_1970_1980 = '1970_1980',
  PERIOD_1981_1991 = '1981_1991',
  PERIOD_1992_2000 = '1992_2000',
  PERIOD_2001_2010 = '2001_2010',
  PERIOD_2011_2018 = '2011_2018',
  SINCE_2019 = 'since_2019',
}

export enum PropertyStanding {
  LUXURY = 'luxury',
  PREMIUM = 'premium',
  MID_RANGE = 'mid_range',
  ENTRY_LEVEL = 'entry_level',
}

export enum PropertyView {
  SEA = 'sea',
  MOUNTAIN = 'mountain',
  MONUMENT = 'monument',
  UNOBSTRUCTED = 'unobstructed',
  GARDEN = 'garden',
  CITY = 'city',
  STREET = 'street',
  QUIET = 'quiet',
  OPPOSITE = 'opposite',
}

export enum PropertySaleUrgency {
  AS_SOON_AS_POSSIBLE = 'as_soon_as_possible',
  ONE_TO_THREE_MONTHS = 'one_to_three_months',
  THREE_TO_SIX_MONTHS = 'three_to_six_months',
  MORE_THAN_SIX_MONTHS = 'more_than_six_months',
}

export enum PropertyCurrentMarketingMode {
  AGENCY_SIMPLE = 'agency_simple',
  AGENCY_EXCLUSIVE = 'agency_exclusive',
  PAP = 'pap',
  AGENCY_AND_PAP = 'agency_and_pap',
}

export enum PropertyVerificationStatus {
  UNVERIFIED = 'unverified',
  VERIFIED = 'verified',
  REJECTED = 'rejected',
  FLAGGED = 'flagged',
}

export enum PropertyDocumentStatus {
  PENDING_REVIEW = 'pending_review',
  VERIFIED = 'verified',
  REJECTED = 'rejected',
}

export enum PropertyModerationStatus {
  TODO = 'todo',
  FALSE_POSITIVE = 'false_positive',
  FLAGGED = 'flagged',
}

export enum PropertySellerRole {
  OWNER = 'owner',
  FAMILY = 'family',
  ESTATE_HEIR = 'estate_heir',
  COMPANY = 'company',
}

export enum PropertyMemberRole {
  CO_OWNER = 'co_owner',
  VIEWER = 'viewer',
}

export enum PropertyMemberStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
}

export enum PropertyResidenceType {
  MAIN = 'main', // Résidence principale
  SECONDARY = 'secondary', // Résidence secondaire
  RENTAL_INVESTMENT = 'rental_investment', // Investissement locatif
}

export enum PropertyDocumentType {
  OWNERSHIP = 'ownership',
  DPE = 'dpe',
  CO_OWNERSHIP = 'co_ownership',
  FLOOR_PLAN = 'floor_plan',
  OTHER = 'other',
}

export type PropertySubtype =
  | PropertyApartmentSubType
  | PropertyHouseSubType
  | PropertyCommercialSubType
  | PropertyLandSubType
  | PropertyParkingSubType
  | PropertyProfessionalSubType;

export enum PropertyMandateType {
  EXCLUSIVE = 'exclusive',
  SEMI_EXCLUSIVE = 'semi_exclusive',
  SIMPLE = 'simple',
}

export enum PropertyMandateDuration {
  TWO_MONTHS = '2_months',
  THREE_MONTHS = '3_months',
  SIX_MONTHS = '6_months',
  FLEXIBLE = 'flexible',
}

export enum PropertySellerPriority {
  SPEED = 'speed',
  MAX_PRICE = 'max_price',
  PREMIUM_VISUALS = 'premium_visuals',
  QUALIFIED_BUYERS = 'qualified_buyers',
  VALUATION = 'valuation',
  DAILY_REPORTS = 'daily_reports',
  FULL_DELEGATION = 'full_delegation',
}

export enum PropertyKeyManagement {
  AGENT_KEY_DOUBLE = 'agent_key_double',
  KEY_BOX = 'key_box',
  BY_APPOINTMENT_OWNER = 'by_appointment_owner',
}

export enum PropertyCreationStep {
  DEFINITION = 0,
  LOCATION = 1,
  CADASTRAL = 2,
  DPE = 3,
  KEY_INFOS = 4,
  CONSTRUCTION = 5,
  CHARACTERISTICS = 6,
  GEOHAZARDS = 7,
  PRESENTATION = 8,
  PHOTOS = 9,
  FINANCIALS = 10,
  MANDATE = 11,
  OWNERSHIP_DOCUMENT = 12,
  COMPLETED = 13,
}

export const PROPERTY_CREATION_STEP_SLUGS = [
  'definition',
  'location',
  'cadastral',
  'dpe',
  'key-infos',
  'construction',
  'characteristics',
  'geohazards',
  'presentation',
  'photos',
  'financials',
  'mandate',
  'ownership-document',
  'completed',
] as const;

export type PropertyCreationStepSlug = (typeof PROPERTY_CREATION_STEP_SLUGS)[number];

export enum PropertyMarketState {
  FOR_SALE = 'for_sale',
  UNDER_MANDATE = 'under_mandate',
  UNDER_OFFER = 'under_offer',
  UNDER_CONTRACT = 'under_contract',
  SOLD = 'sold',
  WITHDRAWN = 'withdrawn',
}

export enum PropertyCreationSource {
  OWNER = 'owner',
  AGENT = 'agent',
  ADMIN = 'admin',
}
